import { ChangeDetectionStrategy, Component, output } from '@angular/core';

import { ButtonsModule } from '~ng-common-lib/ui/buttons';

@Component({
	selector: 'client-menu-clear-button',
	templateUrl: './menu-clear-button.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [ButtonsModule],
	host: {
		class: 'block',
	},
})
export class ClientMenuClearButtonComponent {
	public readonly clear$ = output({ alias: 'clear' });

	public clear(): void {
		this.clear$.emit();
	}
}
